<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Select Company </label>
          <v-select
            v-model="selected_company"
            :options="companies"
            label="name"
            :reduce="c => c.company_unique_id"
            placeholder="Select your Company"
            @change="fetchTransactions"
          />
        </div>
      </div>
    </div>

    <loading v-if="loading" />
    <template v-else>
      <table
        v-if="transactions.length"
        class="table table-striped table-responsive-sm"
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Account</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Transaction Date</th>
            <th>Transaction</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, i) in transactions"
            :key="i"
          >
            <td>{{ i + pagination.from }}</td>
            <td>{{ item.account }}</td>
            <td>{{ item.payable_type }}</td>
            <td>{{ $number.format(item.amount) }}</td>
            <td>{{ item.transaction_date }}</td>
            <td>{{ getPayType(item.type) }}</td>
          </tr>
        </tbody>
      </table>
      <div
        v-else
        class="alert alert-warning"
      >
        <p>There are no transactions</p>
      </div>
      <pagination
        v-if="pagination.last_page > 1"
        :pagination="pagination"
        :offset="5"
        @paginate="fetchTransactions"
      />
    </template>
  </div>
</template>

<script>
import $ from 'jquery';
export default {
  data() {
    return {
      companies: [],
      transactions: [],
      selected_company: {company_unique_id: '', name: ''},
      loading: true,
      pagination: {
        'current_page': 1,
        'last_page': 1,
        'from': 1
      }
    }
  },
  watch: {
    companies() {
      setTimeout(() => {
        $('.table').DataTable();
      }, 1000);
    },
    selected_company(newval, oldval) {
      if (newval != null && newval !== oldval)
        this.fetchTransactions()
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.$axios.get('/api/v1/companies/approved/options').then(response => {
        this.companies = response.data;
        this.loading = false;
      });
    },
    fetchTransactions() {
      this.loading = true;
      this.$axios.get('/api/v1/wallets/transactions/Company/' + this.selected_company + '?page=' + this.pagination.current_page).then(response => {
        this.loading = false;
        if (!Object.prototype.hasOwnProperty.call(response.data, "data")) return;
        this.transactions = response.data.data;
        this.pagination = (({total, per_page, current_page, last_page, from, to}) => ({
          total,
          per_page,
          current_page,
          last_page,
          from,
          to
        }))(response.data);
      });
    },
    getPayType(item) {
      return item === 'credit' ? 'Payment' : 'Top Up'
    }
  }
}
</script>
